var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from "@emotion/react";
import { Box } from "@mui/material";
import { TabPanelLayout } from "./Tabs.styles";
var TabPanel = function (props) {
    var children = props.children, hidden = props.hidden, index = props.index, id = props.id, overflowY = props.overflowY;
    var baseCSS = TabPanelLayout.panel;
    return (_jsx("div", __assign({ role: "tabpanel", hidden: hidden, id: "".concat(id, "-").concat(index), "aria-labelledby": "".concat(id, "-").concat(index) }, { children: !hidden && (_jsx(Box, __assign({ css: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            ", ";\n            ", ";\n          "], ["\n            ", ";\n            ", ";\n          "])), baseCSS, overflowY ? "overflow-y: auto" : "overflow-y: visible") }, { children: children }))) })));
};
export default TabPanel;
var templateObject_1;
